import styled from "styled-components";

export const GridViewWrapper = styled.div`
  display: grid;
  justify-content: center;
`;
